import React, { useState } from 'react'
import { Center, Spinner } from 'front-end/src/components'
import { EventSelectorForm } from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/modals/event-modal/event-selector/EventSelectorForm'
import { useQuickSearchQuery } from 'front-end/src/components/common/selectEntitiesForm/SelectEntitiesForm.codegen'
import { SearchableItemTypesEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { EventSelectorContext } from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/modals/event-modal/event-selector/EventSelectorContext'
import { getChangedSelectedEvents } from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/modals/event-modal/event-selector/helpers'
import { useRecurringEventsByIdsLazyQuery } from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/modals/event-modal/event-selector/EventSelector.codegen'
import { SearchableEntity } from 'front-end/src/components/common/selectEntitiesForm'

export type selectedEventsType = { events: number[]; recEvents: number[] }
export type changeSelectedEventsType = (
  eventId: number,
  isRecurring?: boolean
) => void

export const EventSelector = ({
  selectedEvents,
  setSelectedEvents
}: {
  selectedEvents: selectedEventsType
  setSelectedEvents: (selectedEvents: selectedEventsType) => void
}) => {
  const [events, setEvents] = useState<SearchableEntity[]>([])
  const [recEvents, setRecEvents] = useState<SearchableEntity[]>([])
  const [isLoaded, setIsLoaded] = useState(false)
  const [getRecEventsByIds] = useRecurringEventsByIdsLazyQuery({
    onCompleted: (data) => {
      const recEventsWithOccs = data.admin.recurringEvents.map((recEvent) => {
        return {
          ...recEvent,
          // @ts-ignore
          events: events.filter((ev) => ev.recurring_event_id === recEvent.id)
        }
      })
      setRecEvents(recEventsWithOccs)
      setIsLoaded(true)
    }
  })
  useQuickSearchQuery({
    variables: {
      titleFilter: '',
      include: [SearchableItemTypesEnum.events]
    },
    onCompleted: (data) => {
      setEvents(
        data.admin.quickSearch
          .filter((n) => n.id)
          .filter((v, i, a) => a.findIndex((v2) => v2.id === v.id) === i)
      )
      const recIds = data.admin.quickSearch.map(
        (event) => event.recurring_event_id
      )

      const uniqueRecIds = [...new Set(recIds)].filter((n) => n)
      getRecEventsByIds({
        variables: {
          ids: uniqueRecIds
        }
      })
    }
  })

  if (!isLoaded) {
    return (
      <Center py="20px">
        <Spinner />
      </Center>
    )
  }

  const changeSelectedEvents = (eventId: number, isRecurring = false) => {
    let recEventId = isRecurring
      ? eventId
      : // @ts-ignore
        events.find((event) => event.id === eventId).recurring_event_id

    const recEvent = recEvents.find((re) => re.id === recEventId)

    const { newEvents, newRecEvents } = getChangedSelectedEvents(
      eventId,
      isRecurring,
      selectedEvents,
      recEvent as any
    )

    setSelectedEvents({
      events: newEvents,
      recEvents: newRecEvents
    })
  }

  return (
    <EventSelectorContext.Provider
      value={{
        selectedEvents,
        changeSelectedEvents
      }}
    >
      <EventSelectorForm
        allEvents={{
          events,
          recEvents
        }}
      />
    </EventSelectorContext.Provider>
  )
}
